import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({

  state: {
    count: 1
  },
  getters: {
        oddCount: state => {
            if(state.count % 2 === 0){
                return state.count
        }
      }
    },
  mutations: {
    increment (state, n) {
        state.count += n
        console.log(state.count)
      }
  },
  actions: {
    incrementAsync (context, n) {
      setTimeout(() => {
        context.commit('increment',n)
      }, 1000)
    }
  }
})
